import { render, staticRenderFns } from "./TitleAdmin.vue?vue&type=template&id=28aa30d6&"
import script from "./TitleAdmin.vue?vue&type=script&lang=js&"
export * from "./TitleAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports